module.exports = __webpack_public_path__ + "img/Roque_Imoveis@2x.ed837f0c.png";